
import { useState, useEffect } from "react"
// import { useRouter } from "next/router"
import styled from "styled-components"
import { X, Upload, Trash2 } from "lucide-react"
import { useNavigate, useParams } from "react-router-dom"
import { ProductImages } from "../components/EditProductImg"
import toast from 'react-hot-toast';
import { ProductSizes } from "../components/ProductSizes"
// export const API = "https://api-javabicicletas-77db5a759140.herokuapp.com"
export const API = "https://api-javabikes-production-d99f.up.railway.app"
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #1E1F23;
  color: #FFFFFF;
`

const Header = styled.header`
  background-color: #2A2B2E;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Title = styled.h1`
  margin: 0;
  font-size: 1.5rem;
`

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 1.5rem;
`

const Content = styled.div`
  display: flex;
  flex: 1;
  padding: 20px;
  gap: 20px;
  
  @media (max-width: 1200px) {
    flex-direction: column;
  }


`

const FormSection = styled.div`
  margin-top: 20px;
  flex: 2;
`

const ImageSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const Form = styled.form`
  display: flex;
  margin-top: 30px;
  flex-direction: column;
  gap: 20px;
`

const Select = styled.select`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #3A3B3E;
  color: white;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.label`
  font-size: 0.9rem;
`

const Input = styled.input`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #3A3B3E;
  color: white;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`

const ColorInput = styled(Input)`
  height: 40px;
  padding: 5px;
`

const Button = styled.button`
  padding: 12px 20px;
  border-radius: 4px;
  border: none;
  background-color: #4A88F3;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #3B78E0;
  }

  &:disabled {
    background-color: #4A4B4F;
    cursor: not-allowed;
  }
`

const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`

const ImageWrapper = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
`
const TextArea = styled.textarea`
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #4A4B4F;
  background-color: #3A3B3E;
  color: white;
  font-size: 1rem;
  min-height: 100px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #4A88F3;
  }
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
`

const DeleteImageButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: white;
`

const FormSection2Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }`

export default function EditProductPage({ create }) {
  const { id } = useParams()
  const [product, setProduct] = useState(null)
  const navigate = useNavigate()
  useEffect(() => {
    // Simular la carga del producto desde una API
    if (id && !create) {
      // En un caso real, aquí harías una llamada a tu API
      fetch(`${API}/api/productos/productos/${id}`, {
        headers: {
            "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjp7ImlkIjoxfSwiaWF0IjoxNzM5NjI5MjE1LCJleHAiOjE3Mzk3MTU2MTV9.E9XX1oOng0xRc5XwxVcNEHpUstDX6YMK-jvguoSscYg"
        }
      })
      .then((response) => response.json())
      .then((data) => {
        console.log({ producto: data})
        data.producto.tallas = JSON.parse(data.producto.tallas)
        data.producto.img = JSON.parse(data.producto.img)
        data.producto.colores = data.producto.img.map((img) => img.color)
        data.producto.img.map((img) => {
          img.isPrimary = img.isPrimary === "true"
        })
        setProduct(data.producto)
      })

    } else setProduct({
      img: [],
      nombre: '',
      sku: '',
      status: 0,
      precio: '',
      categorias: '',
      colores: [],
      fecha: '',
      marco: '',
      tenedor: '',
      llanta_delantera: '',
      llanta_trasera: '',
      cambiador: '',
      descarrilador_delantero: '',
      descarrilador_trasero: '',
      platos_vielas: '',
      cassette: '',
      cadena: '',
      ejes: '',
      frenos: '',
      manubrio: '',
      vastago_manubrio: '',
      tija_sillin: '',
      sillin: '',
      descripcion: '',
      peso: '',
      tipo_marco: '',
      rines: '',
      grupo: '',
      tallas: [],
      tamano_marco: ''})
  }, [id])

  const handleChange = (e) => {
    if (product) {
      const { name, value } = e.target
      setProduct((prev) => ({
        ...prev,
        [name]: name === "inventory" || name === "price" ? Number.parseFloat(value) : value,
      }))
    }
  }

  const handleColorChange = (index, color) => {
    if (product) {
      const newColors = [...product.colors]
      newColors[index] = color
      setProduct({ ...product, colors: newColors })
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (product && !create) {

      const productUpdate = {
        ...product,
        status: parseInt(product.status),
        img: JSON.stringify(product.img),
        tallas: JSON.stringify(product.tallas),
        colores: JSON.stringify(product.img.map((img) => img.color))
      }
      console.log(productUpdate)
      const pet = await fetch(`${API}/api/productos/${id}`,{
        method: 'PUT',
        body: JSON.stringify(productUpdate),
        headers:{
          "Content-Type": "application/json",
          "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjp7ImlkIjoxfSwiaWF0IjoxNzM5NjI5MjE1LCJleHAiOjE3Mzk3MTU2MTV9.E9XX1oOng0xRc5XwxVcNEHpUstDX6YMK-jvguoSscYg"
        }
      })
      const updatedProduct = await pet.json()
      toast.success('Producto actualizado con éxito')
      // Aquí iría la lógica para guardar los cambios del producto
      console.log("Producto actualizado:", updatedProduct)
      // router.push("/products") // Redirigir a la lista de productos
    } else {
      const productCreate = {
        ...product,
        img: JSON.stringify(product.img),
        tallas: JSON.stringify(product.tallas),
        colores: JSON.stringify(product.colores),
        status: parseInt(product.status),
        precioAntes: Number(product.precioAntes),
        precio: Number(product.precio)
      }
      if (!product.fecha) return toast.error("La fecha es necesaria")
      const pet = await fetch(`${API}/api/productos/`,{
        method: 'POST',
        body: JSON.stringify(productCreate),
        headers:{
          "Content-Type": "application/json",
           "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjp7ImlkIjoxfSwiaWF0IjoxNzM5NjI5MjE1LCJleHAiOjE3Mzk3MTU2MTV9.E9XX1oOng0xRc5XwxVcNEHpUstDX6YMK-jvguoSscYg"
        }
      })
      const createdProduct = await pet.json()
      toast.success('Producto creado con éxito')
      navigate(`/administracion/edit/${createdProduct.producto.id}`)
      // Aquí iría la lógica para guardar los cambios del producto
      
      // router.push("/products") // Redirigir a la lista de productos
    }
  }

  const handleAddImage = async (newImage) => {
    if (product) {
      const formData = new FormData();
      formData.append('file', newImage.url);
      formData.append('id', id);
      formData.append('color', newImage.color);
      formData.append('isPrimary', newImage.isPrimary);

      const pet = await fetch(`${API}/api/productos/upload/`,{
        method: 'POST',
        headers: {
           "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjp7ImlkIjoxfSwiaWF0IjoxNzM5NjI5MjE1LCJleHAiOjE3Mzk3MTU2MTV9.E9XX1oOng0xRc5XwxVcNEHpUstDX6YMK-jvguoSscYg"
        },
        body: formData
      })
      const image = await pet.json()
      product.colores.push(image.img.color)
      image.img.isPrimary = image.img.isPrimary === "true"
      setProduct({
        ...product,
        img: [...product.img, image.img],
      })
      toast.success('Imagen agregada con éxito')
    }
  }

  const handleDeleteImage = async (image) => {
    if (product) {
      const formData = new FormData();
      formData.append('url', image.url.public_id);
      formData.append('id', id);
      const pet = await fetch(`${API}/api/productos/delete/image`,{
        method: 'POST',
        headers: {
           "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjp7ImlkIjoxfSwiaWF0IjoxNzM5NjI5MjE1LCJleHAiOjE3Mzk3MTU2MTV9.E9XX1oOng0xRc5XwxVcNEHpUstDX6YMK-jvguoSscYg"
        },
        body: formData
      })
      const images = await pet.json()
      product.colores = images.img.map((img) => img.color)
      setProduct({ ...product, img: images.img })
      toast.success('Imagen eliminada con éxito')
    }
  }

  const handleEditImage = async (index, editedImage) => {
    console.log(index)
    if (product) {
      const formData = new FormData();
      formData.append('file', editedImage.url);
      formData.append('oldImg', JSON.stringify(product.img[index].url));
      formData.append('id', id);
      formData.append('color', editedImage.color);
      formData.append('isPrimary', editedImage.isPrimary);
      const pet = await fetch(`${API}/api/productos/update/image`,{
        method: 'POST',
        headers:{
           "Authorization": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjp7ImlkIjoxfSwiaWF0IjoxNzM5NjI5MjE1LCJleHAiOjE3Mzk3MTU2MTV9.E9XX1oOng0xRc5XwxVcNEHpUstDX6YMK-jvguoSscYg"
        },
        body: formData
      })
      const imageNew = await pet.json()
      toast.success('Imagen actualizada con éxito')
      if (imageNew.img.color != "") product.colores[index] = imageNew.img.color
      const newImages = [...product.img]
      imageNew.img.isPrimary = imageNew.img.isPrimary === "true"
      newImages[index] = imageNew.img
      setProduct({ ...product, img: newImages })
    }
  }


  const handleAddSize = (newSize) => {
    if (product) {
      fetch(`${API}/api/productos/tallas`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          newSize: JSON.stringify(newSize),
          id: id,
          operation: "create"
        })
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          return toast.error(data.error)
        }
        setProduct({
          ...product,
          tallas: [...product.tallas, data.newSize],
        })
        toast.success('Talla agregada con éxito');
      })
     
    }
  }

  const handleEditSize = (idx, updatedSize) => {
    if (product) {
      fetch(`${API}/api/productos/tallas`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          newSize: JSON.stringify(updatedSize),
          id: id,
          operation: "edit"
        })
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          return toast.error(data.error)
        }

        const newSizes = product.tallas.map((size) => (size.id === idx ? data.updatedSize : size))
       setProduct({
        ...product,
        tallas: newSizes,
      })
      toast.success('Talla actualizada con éxito');
      })

    }
  }

  const handleDeleteSize = (idx) => {
    if (product) {
      fetch(`${API}/api/productos/tallas`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          newSize: idx,
          id: id,
          operation: "delete"
        })
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          return toast.error(data.error)
        }
        console.log(data)
        const newSizes = product.tallas.filter((size) => size.id != data.newSize)
        setProduct({
          ...product,
          tallas: newSizes,
        })
      toast.success('Talla eliminada con éxito');
      })

    
    }
  }

  

  if (!product) {
    return <div>Cargando...</div>
  }

  return (
    <PageContainer>
      <Content>
      <FormSection>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label htmlFor="nombre">Nombre del producto</Label>
              <Input id="nombre" name="nombre" value={product.nombre} onChange={handleChange}  />
            </FormGroup>
            <FormSection2Columns>
              <FormGroup>
                <Label htmlFor="sku">SKU</Label>
                <Input id="sku" name="sku" value={product.sku} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="status">Estado de Producto</Label>
                  <Select
                    id="status"
                    name="status"
                    value={product.status}
                    onChange={handleChange}
                    required
                  >
                    <option value="0" selected>Activo</option>
                    <option value="1">Inactivo</option>
                  </Select>

              </FormGroup>
              <FormGroup>
                <Label htmlFor="precioAntes">Precio Antes</Label>
                <Input
                  id="precioAntes"
                  name="precioAntes"
                  type="number"
                  value={product.precioAntes}
                  onChange={handleChange}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="precio">Precio Actual</Label>
                <Input
                  id="precio"
                  name="precio"
                  type="number"
                  value={product.precio}
                  onChange={handleChange}
                  
                />
              </FormGroup>
            </FormSection2Columns>
            <FormGroup>
              <Label htmlFor="categorias">Categoría</Label>
              <Input
                id="categorias"
                name="categorias"
                value={product.categorias}
                onChange={(e) => setProduct({ ...product, categorias: e.target.value})}
                
              />
            </FormGroup>
            <FormGroup>
              <Label>Colores (Los colores se editan en su respectiva imagen)</Label>
              <div style={{ display: "flex", gap: "10px" }}>
              {product?.colores?.map((color, index) => {
                if (color == "") return
                return (
                  <ColorInput
                  key={index}
                  type="color"
                  value={color}
                  />
                )
              } 
              )}
              </div>
            </FormGroup>
            <FormGroup>
              <Label htmlFor="fecha">Fecha</Label>
              <Input id="fecha" name="fecha" type="date" value={product.fecha} onChange={handleChange}  />
            </FormGroup>
            <FormSection2Columns>
              <FormGroup>
                <Label htmlFor="marco">Marco</Label>
                <Input id="marco" name="marco" value={product.marco} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="tenedor">Tenedor</Label>
                <Input id="tenedor" name="tenedor" value={product.tenedor} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="llanta_delantera">Llanta Delantera</Label>
                <Input
                  id="llanta_delantera"
                  name="llanta_delantera"
                  value={product.llanta_delantera}
                  onChange={handleChange}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="llanta_trasera">Llanta Trasera</Label>
                <Input
                  id="llanta_trasera"
                  name="llanta_trasera"
                  value={product.llanta_trasera}
                  onChange={handleChange}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="cambiador">Cambiador</Label>
                <Input id="cambiador" name="cambiador" value={product.cambiador} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="descarrilador_delantero">Descarrilador Delantero</Label>
                <Input
                  id="descarrilador_delantero"
                  name="descarrilador_delantero"
                  value={product.descarrilador_delantero}
                  onChange={handleChange}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="descarrilador_trasero">Descarrilador Trasero</Label>
                <Input
                  id="descarrilador_trasero"
                  name="descarrilador_trasero"
                  value={product.descarrilador_trasero}
                  onChange={handleChange}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="platos_vielas">Platos y Vielas</Label>
                <Input
                  id="platos_vielas"
                  name="platos_vielas"
                  value={product.platos_vielas}
                  onChange={handleChange}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="cassette">Cassette</Label>
                <Input id="cassette" name="cassette" value={product.cassette} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="cadena">Cadena</Label>
                <Input id="cadena" name="cadena" value={product.cadena} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="ejes">Ejes</Label>
                <Input id="ejes" name="ejes" value={product.ejes} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="frenos">Frenos</Label>
                <Input id="frenos" name="frenos" value={product.frenos} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="manubrio">Manubrio</Label>
                <Input id="manubrio" name="manubrio" value={product.manubrio} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="vastago_manubrio">Vástago Manubrio</Label>
                <Input
                  id="vastago_manubrio"
                  name="vastago_manubrio"
                  value={product.vastago_manubrio}
                  onChange={handleChange}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="tija_sillin">Tija Sillín</Label>
                <Input
                  id="tija_sillin"
                  name="tija_sillin"
                  value={product.tija_sillin}
                  onChange={handleChange}
                  
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="sillin">Sillín</Label>
                <Input id="sillin" name="sillin" value={product.sillin} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="peso">Peso</Label>
                <Input id="peso" name="peso" value={product.peso} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="tipo_marco">Tipo de Marco</Label>
                <Input id="tipo_marco" name="tipo_marco" value={product.tipo_marco} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="rines">Rines</Label>
                <Input id="rines" name="rines" value={product.rines} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="grupo">Grupo</Label>
                <Input id="grupo" name="grupo" value={product.grupo} onChange={handleChange}  />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="tamano_marco">Tamaño del Marco</Label>
                <Input
                  id="tamano_marco"
                  name="tamano_marco"
                  value={product.tamano_marco}
                  onChange={handleChange}
                  
                />
              </FormGroup>
            </FormSection2Columns>
            <FormGroup>
              <Label htmlFor="descripcion">Descripción</Label>
              <TextArea
                id="descripcion"
                name="descripcion"
                value={product.descripcion}
                onChange={handleChange}
                
              />
            </FormGroup>
            <Button type="submit">Guardar Cambios</Button>
          </Form>
        </FormSection>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <div>
        <ProductImages images={product.img} create={create} onAddImage={handleAddImage} onDeleteImage={handleDeleteImage}  onEditImage={handleEditImage}/>
        </div>
        <div>
        <ProductSizes
          sizes={product?.tallas}
          onAddSize={handleAddSize}
          onEditSize={handleEditSize}
          onDeleteSize={handleDeleteSize}
          create={create}
          />
        </div>
        </div>

      </Content>
    </PageContainer>
  )
}
